<template>
  <a-row :gutter="12">
    <a-col :span="8">
      <a-card title="Document">
        <a-form-model ref="docForm" :model="form" :rules="rules">
          <a-form-model-item label="Description Document" prop="description">
            <a-input placeholder="Entri Document Description" v-model="form.description"></a-input>
          </a-form-model-item>
          <a-form-model-item label="Select Document" prop="document">
            <a-upload
              accept="*"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-model-item>
        </a-form-model>
        <div class="doc-viewer" v-if="form.document !== null">
          <a-button
            type="danger"
            ghost
            size="small"
            class="close"
            icon="close"
          ></a-button>
          <a-icon
            class="icon"
            :type="
              JSON.parse(JSON.stringify(form.document.type)) ==
              'application/pdf'
                ? 'file-pdf'
                : JSON.parse(JSON.stringify(form.document.type)) == 'image/jpeg'
                ? 'file-image'
                : 'file'
            "
          />
          <div class="detail">
            <h4 class="margin-remove m-text-dots">
              {{ JSON.parse(JSON.stringify(form.document.name)) }}
            </h4>
            <small>{{ JSON.parse(JSON.stringify(form.document.type)) }}</small>
          </div>
        </div>
        <div class="action">
          <a-button @click="handleSubmit()" type="primary" icon="plus"
            >Submit</a-button
          >
        </div>
      </a-card>
    </a-col>
    <a-col :span="16">
      <a-card title="Supporting Document List">
        <a-list
          item-layout="horizontal"
          :data-source="getDocumentTerminRelease"
          :hidden="getDocumentTerminRelease.length == 0"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <template slot="actions">
              <a-button
                @click="handleRemove(item, index)"
                type="danger"
                icon="delete"
                >Delete</a-button
              ></template
            >
            <a-list-item-meta>
              <template v-if="mode == 'Create'">
                <h4 slot="title">
                  {{ item.description }}
                </h4>
                <p slot="description">
                  {{ JSON.parse(JSON.stringify(item.document.name)) }}
                </p>
              </template>
              <template v-else>
                <h4 slot="title">
                  {{ item.nama_file ? item.nama_file : item.description }}
                </h4>
                <p slot="description">
                  {{ item.desc ? item.desc : item.name }}
                </p>
              </template>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <a-list
          v-if="getNewDocumentTerminRelease.length > 0"
          item-layout="horizontal"
          :data-source="getNewDocumentTerminRelease"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <template slot="actions"
              ><a-button
                @click="handleRemoveNew(item, index)"
                type="danger"
                icon="delete"
                >Delete</a-button
              ></template
            >
            <a-list-item-meta>
              <template v-if="mode == 'Create'">
                <h4 slot="title">
                  {{ item.description }}
                </h4>
                <p slot="description">
                  {{ JSON.parse(JSON.stringify(item.name)) }}
                </p>
              </template>
              <template v-else>
                <h4 slot="title">
                  {{ item.nama_file ? item.nama_file : item.description }}
                </h4>
                <p slot="description">
                  {{ item.desc ? item.desc : item.name }}
                </p>
              </template>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import nanoid from "nanoid";
export default {
  name: "document",
  props: { dataProcessed: {}, mode: String },
  data() {
    return {
      form: {
        description: "",
        document: null,
      },
      rules: {
        description: {
          required: true,
          message: "Please input description document",
          trigger: "blur",
        },
        document: {
          required: true,
          message: "Please select a document",
          trigger: "change",
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getDocumentTerminRelease", "getDeletedDocumentTerminRelease", "getNewDocumentTerminRelease"]),
  },
  methods: {
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.form.document = file;

        return false;
      }
    },
    handleSubmit() {
      this.$refs.docForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.form.id = nanoid();
        if (this.mode == "Edit") {
          this.$store.commit("setNewDocumentTerminRelease", this.form);
        } else {
          this.$store.dispatch("setDocumentTerminRelease", this.form);
        }
        this.resetForm();
      });
    },
    resetForm() {
      this.form = {
        description: "",
        document: null,
      };
    },
    handleRemove(item, index) {
      this.$store.dispatch("removeDocumentTerminRelease", item);
    },
    handleRemoveNew(item, index) {
      this.$store.commit("removeNewDocumentTerminRelease", item);
    },
    handleRef() {
      if ((this.getDocumentTerminRelease.length+this.getNewDocumentTerminRelease.length)==0){
        this.displayMessageValue("error-other", "Supporting Document List can't be empty!");
      }else{
        if(this.mode=="Edit"){
          Event.$emit("terminReleaseData", this.getNewDocumentTerminRelease);
        }else{
          Event.$emit("terminReleaseData", this.getDocumentTerminRelease);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  border-top: 1px solid darken(white, 10);
  height: 50px;
  margin-top: @margin;
  padding: @padding 0;
}

.doc-viewer {
  margin-top: 0.5em;
  border: 1px solid darken(white, 10);
  padding: 5px 0;
  min-height: 50px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background-color: darken(white, 2);
  position: relative;

  .icon {
    font-size: 3.5em;
    color: orangered;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.5em;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>